export default __webpack_public_path__ + "static/media/Group9229.ee6e9913.svg";